import React, { useState } from "react";
import SearchInput from "../../../../components/CustomSearchInput";
import { useLocation } from "react-router-dom";
import { InputAdornment, IconButton } from "@material-ui/core";
import { SearchIcon } from "../../../../components/CustomIcons";
import General from "./General";
import Applicants from "./Applicants.js";
import Requests from "./Requests";
import IdealTalents from "./IdealTalents";

const Jobs = () => {
  const { pathname } = useLocation();
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const isApplicantsPage = pathname.includes("applicants");

  const handleSearchSubmit = () => {
    setSearch(searchInput);
  };

  return (
    <div className="my-4 mx-1 mx-md-4">
      {!pathname.includes("ideal-talents") && (
        isApplicantsPage ? (
          <SearchInput
            handleChange={(e) => {
              setSearchInput(e.target.value);
            }}
            value={searchInput}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleSearchSubmit();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleSearchSubmit} size="small">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <SearchInput
            handleChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        )
      )}
      <div className="w-100 my-4">
        {isApplicantsPage ? (
          <Applicants search={search} onClearSearch={() => { setSearch(""); setSearchInput(""); }} />
        ) : pathname.includes("requests") ? (
          <Requests />
        ) : pathname.includes("ideal-talents") ? (
          <IdealTalents />
        ) : (
          <General search={search} />
        )}
      </div>
    </div>
  );
};

export default Jobs;
